<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-goods"></i> 日常消耗</span>
      </div>

      <el-form
        :model="queryParams"
        :inline="true"
        label-position="right"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
        <!-- 分类 -->
        <el-form-item label="物资类别">
          <el-input
            v-model="queryParams.categoryName"
            placeholder="请输入物资类别"
            clearable
            style="width: 250px"
          />
        </el-form-item>
        <el-form-item label="物资名称">
          <el-input
            v-model="queryParams.name"
            placeholder="请输入物资名称"
            clearable
            style="width: 250px"
          />
        </el-form-item>

        <div>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
            >搜索</el-button
          >
          <el-button @click="resetQuery">重置</el-button>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="openAddMaterialDialog"
          >
            新增物资
          </el-button>
        </div>
      </el-form>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column
          prop="categoryName"
          label="物资类别"
          fixed
        ></el-table-column>
        <el-table-column prop="name" label="物资名称" fixed></el-table-column>
        <el-table-column
          prop="supplierName"
          label="供应商"
          fixed
        ></el-table-column>
        <el-table-column label="物资图片">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.image"
              :preview-src-list="[scope.row.image]"
              fit="cover"
            />
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="单位"></el-table-column>
        <el-table-column prop="stockInCount" label="入库数量"></el-table-column>
        <el-table-column prop="loanOutCount" label="借出数量"></el-table-column>
        <el-table-column prop="scrapCount" label="报废数量"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="creatorName" label="创建人"></el-table-column>
        <!-- 操作列 -->
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="openScrapDialog(scope.row)"
              type="danger"
              >报废出库</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />

      <!-- 新增物资弹窗 -->
      <el-dialog
        title="新增物资"
        :visible.sync="materialDialogVisible"
        width="600px"
        @close="resetMaterialForm"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="materialForm"
          :rules="materialRules"
          ref="materialFormRef"
          label-width="100px"
        >
          <el-form-item label="物资类别" prop="categoryId">
            <el-select
              v-model="materialForm.categoryId"
              placeholder="请选择物资类别"
              style="width: 400px"
            >
              <el-option
                v-for="item in categoryOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="物资名称" prop="name">
            <el-input
              v-model="materialForm.name"
              placeholder="请输入物资名称"
              style="width: 400px"
            />
          </el-form-item>

          <el-form-item label="供应商" prop="supplierId">
            <el-select
              v-model="materialForm.supplierId"
              placeholder="请选择供应商"
              style="width: 400px"
            >
              <el-option
                v-for="item in supplierList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="物资图片" prop="images">
            <el-upload
              :headers="uploadHeaders"
              :action="UPLOAD_URL"
              list-type="picture-card"
              :file-list="materialForm.images"
              :on-remove="handleImageRemove"
              :on-success="handleImageSuccess"
              :on-exceed="handleExceed"
              :limit="1"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="单位" prop="unit">
            <el-input
              v-model="materialForm.unit"
              placeholder="请输入单位"
              style="width: 400px"
            />
          </el-form-item>

          <el-form-item label="备注">
            <el-input
              v-model="materialForm.remark"
              placeholder="请输入备注"
              style="width: 400px"
            />
          </el-form-item>

          <el-form-item label="入库数量" prop="stockInCount">
            <el-input
              v-model="materialForm.stockInCount"
              type="number"
              placeholder="请输入入库数量"
              style="width: 400px"
            />
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="materialDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveMaterial">保存</el-button>
        </div>
      </el-dialog>

      <!-- 报废出库弹窗 -->
      <el-dialog
        title="报废出库"
        :visible.sync="scrapDialogVisible"
        width="600px"
        @close="resetScrapForm"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="scrapForm"
          :rules="scrapRules"
          ref="scrapFormRef"
          label-width="100px"
        >
          <!-- 物资名称 -->
          <el-form-item label="物资名称" prop="name">
            <el-input
              v-model="scrapForm.name"
              placeholder="请输入物资名称"
              style="width: 400px"
            >
            </el-input>
          </el-form-item>

          <!-- 可用数量 -->
          <el-form-item label="入库数量" prop="availableQuantity">
            <el-input
              v-model="scrapForm.availableQuantity"
              disabled
              style="width: 400px"
            />
          </el-form-item>
          <!-- 数量 -->
          <el-form-item label="报废数量" prop="count">
            <el-input-number
              v-model="scrapForm.count"
              style="width: 400px"
              placeholder="请输入数量"
              :min="1"
              :step="1"
            />
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="scrapDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitScrap">提交</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  dailyAssetsScrapApplicationAdd,
  dailyAssetsPage,
  dailyAssetsAdd,
  assetsCategoryPage,
} from "@/api/material";
import { MAX_PAGE_SIZE, DAILY_NAME, UPLOAD_URL } from "@/utils/const";
import PaginationBar from "@/components/PaginationBar";
import { getToken } from "@/utils/auth";
import { mapState } from "vuex";

export default {
  components: {
    PaginationBar,
  },
  computed: {
    ...mapState(["supplierList"]), // 从 Vuex 获取 userPermissions
  },

  data() {
    return {
      UPLOAD_URL,
      images: "", //提交的数据
      uploadHeaders: {
        token: getToken(), // 替换为你的 token
      },
      imageUrl: "", // 保存上传的图片 URL
      tableData: [],
      queryParams: {
        categoryName: "",
        name: "",
      },
      categoryOptions: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      materialDialogVisible: false,
      materialForm: {
        categoryId: "",
        name: "",
        supplier: "",
        images: [],
        unit: "",
        remark: "",
        stockInCount: null,
      },
      materialRules: {
        categoryId: [
          { required: true, message: "请选择物资类别", trigger: "change" },
        ],
        name: [{ required: true, message: "请输入物资名称", trigger: "blur" }],
        supplier: [
          { required: true, message: "请选择供应商", trigger: "change" },
        ],
        images: [
          { required: false, message: "请上传物资图片", trigger: "change" }, // 非必填
        ],
        unit: [{ required: true, message: "请输入单位", trigger: "blur" }],
        stockInCount: [
          { required: true, message: "请输入入库数量", trigger: "blur" },
        ],
        remark: [
          { required: false, message: "请输入备注", trigger: "blur" }, // 非必填
        ],
      },
      scrapDialogVisible: false, // 控制弹窗的显示
      scrapForm: {
        name: "",
        availableQuantity: "",
        count: "",
      },
      maxQuantity: 0, // 当前物资的最大数量
      scrapRules: {
        name: [
          { required: true, message: "请选择物资名称", trigger: "change" },
        ],
        count: [{ required: true, message: "请输入数量", trigger: "blur" }],
        reason: [
          { required: true, message: "请输入报废缘由", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 报废的清空
    resetScrapForm() {
      this.$refs.scrapFormRef.resetFields();
    },
    handleExceed() {
      this.$message.warning(`本次只能上传1张图片`);
    },

    // 提交报废出库
    submitScrap() {
      // 手动校验数量是否超过最大数量
      if (this.scrapForm.count > this.scrapForm.availableQuantity) {
        this.$message.error(
          `数量不能超过最大数量 ${this.scrapForm.availableQuantity}`
        );
        return; // 如果数量不合法，直接返回，不提交数据
      }

      // 表单验证
      this.$refs.scrapFormRef.validate((valid) => {
        if (valid) {
          // console.log("报废出库数据:", this.scrapForm);
          // 调用接口保存数据
          const params = {
            dailyAssetsId: this.scrapForm.dailyAssetsId,
            count: this.scrapForm.count,
          };
          dailyAssetsScrapApplicationAdd(params).then((res) => {
            this.scrapDialogVisible = false;
            this.$message.success("操作成功");
            this.handleQuery();
          });
        } else {
          console.log("表单验证失败");
          return false;
        }
      });
    },
    // 处理图片移除
    handleImageRemove(file, fileList) {
      this.materialForm.images = fileList;
    },

    // 处理图片变化（上传新图片时）
    handleImageSuccess(data, file) {
      if (data.code === 0) {
        // 上传成功
        this.images = data.data;
      }
      this.materialForm.images.push(file);
    },
    // 保存物资
    saveMaterial() {
      this.$refs.materialFormRef.validate((valid) => {
        if (valid) {
          // 执行保存逻辑
          const params = {
            ...this.materialForm,
            image: this.images,
          };

          dailyAssetsAdd(params).then((res) => {
            this.$message.success("保存成功");
            this.materialDialogVisible = false; // 关闭弹窗
            this.handleQuery();
          });
        } else {
          console.log("表单验证失败");
          return false;
        }
      });
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      dailyAssetsPage({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ...this.queryParams,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    openAddMaterialDialog() {
      this.materialDialogVisible = true;
    },
    resetMaterialForm() {
      this.$refs.materialFormRef.resetFields();
    },
    openScrapDialog(row) {
      this.scrapForm.name = row.name;
      this.scrapForm.availableQuantity =
        parseInt(row.stockInCount) - parseInt(row.loanOutCount);
      this.scrapForm.dailyAssetsId = row.id;
      this.scrapDialogVisible = true;
    },
    getAllDaily() {
      assetsCategoryPage({
        pageNo: 1,
        pageSize: MAX_PAGE_SIZE,
        category: DAILY_NAME, //
      }).then((res) => {
        // console.log('res',res)
        this.categoryOptions = res.records;
      });
    },
    resetQuery() {
      this.queryParams = { name: "", categoryName: "" };
      this.currentPage = 1;
      this.handleQuery();
    },
  },
  created() {
    this.handleQuery();
    // 查询所有的日常消耗
    this.getAllDaily();
  },
};
</script>

<style scoped>
.app-container {
}
.dialog-footer {
  text-align: center;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.upload-limit-tip {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 12px;
  text-align: center;
  padding: 4px 0;
}
</style>
